module.exports = __webpack_public_path__ + "785faad2f7f2323c94ee1b99a26df854.png";